<template>
  <div :class="$attrs.class" class="wrapper">
    <input
      :id="id"
      ref="input"
      v-bind="{ ...$attrs, class: null }"
      class="form-input border-2 border-blue-600"
      :class="{ error: error }"
      type="number"
      :value="modelValue"
      :data-unit="unit"
      @input="update($event.target.value)"
    />
    <div class="arrows">
      <div class="button" @click="up"><div class="arrow-up" /></div>
      <div class="button" @click="down"><div class="arrow-down" /></div>
    </div>
    <span class="unit">{{ unit }}</span>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import throttle from 'lodash/throttle'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `length-input-${uuid()}`
      },
    },
    error: String,
    unit: String,
    modelValue: {
      type: [Number, String],
      default: 0,
    },
    max     : {
      type: Number,
      default: null,
    },
  },
  emits: [
    'update:modelValue',
    'change:modelValue',
  ],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
    up() {
      this.change(this.modelValue + parseFloat(this.$refs.input.step))
    },
    down () {
      this.change(this.modelValue - parseFloat(this.$refs.input.step))
    },
    update: throttle(function (value) {
      if (this.max) {
        if (value > this.max) {
          this.$emit('update:modelValue', this.max)
        } else {
          this.$emit('update:modelValue', value)
        }
      } else {
        this.$emit('update:modelValue', value)
      }
    }, 200),
    change: throttle(function (value) {
      if (this.max) {
        if (value <= this.max) {
          this.$emit('change:modelValue', value)
        }
      } else {
        this.$emit('change:modelValue', value)
      }
    }, 200),
  },
}
</script>

<style scoped >
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
   opacity: 0;
}

.wrapper {
  position: relative;
}
.arrows {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30px;
  position: absolute;
  top: 0;
  right:0;
  bottom: 0;
}

.arrows .button {
  margin : 1.5px 0px;
  padding: 5px;
  cursor : pointer
}

.arrows .button:hover .arrow-up,
.arrows .button:hover .arrow-down {
  border-top-color: gray;
  border-bottom-color: gray;
}

.arrows .arrow-up {
  width: 0;
  height: 0;
  border-right: 6px solid transparent;
  border-left : 6px solid transparent;
  border-bottom  : 6px solid #002B56;
}

.arrows .arrow-down {
  width: 0;
  height: 0;
  border-top  : 6px solid #002B56;
  border-right: 6px solid transparent;
  border-left : 6px solid transparent;
}
.unit {
    position: absolute;
    top: 0;
    right: 30px;
    bottom:0;
    padding:5px;
    color: grey;
    text-align:right;
    vertical-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
